import { Spinner } from 'react-bootstrap';

const Loading = (props) => {
  return (
    <div
      className={`d-flex align-items-center justify-content-center ${
        props.size === 'sm' ? '' : 'w-100'
      } h-100 p-2`}
    >
      <Spinner animation="border" {...props} />
    </div>
  );
};

export default Loading;
